var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFamiliar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40303 13.057C9.18017 12.8263 8.84948 12.8098 8.61224 13.0158C8.58348 13.0405 5.85885 15.3888 3.32113 13.0158C3.09108 12.8016 2.7532 12.8016 2.53034 13.0323C2.4297 13.1312 0.0573265 15.5536 -0.000185512 20.2914C-0.000185512 20.4809 0.0645154 20.6622 0.17954 20.794C0.294564 20.9258 0.452722 21 0.618069 21H11.15C11.4807 21 11.7538 20.6951 11.761 20.3161C11.761 20.1266 11.8689 15.636 9.40303 13.0488V13.057ZM0.903878 20.1297C0.629976 17.6215 2.31541 14.431 2.85459 13.7059C6.02125 15.5154 7.6065 14.6534 8.9149 13.7471C10.7244 15.4212 10.7851 18.9417 10.857 20.0952L0.903878 20.1297Z",
    fill: "#ADB84E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.88049,
    cy: 6.97619,
    r: 4.47619,
    stroke: "#ADB84E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 1L14 3H12L12.0001 5H14.0001V7H16.0001V5H18V3H16.0001V1H14.0001Z",
    stroke: "#ADB84E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFamiliar);
export default __webpack_public_path__ + "static/media/add-familiar.85ae1c28b8f6e21fddeb2f0e3442f3eb.svg";
export { ForwardRef as ReactComponent };